import { render, staticRenderFns } from "./formBaseInvigilando.vue?vue&type=template&id=58eb2297&"
import script from "./formBaseInvigilando.vue?vue&type=script&lang=js&"
export * from "./formBaseInvigilando.vue?vue&type=script&lang=js&"
import style0 from "./formBaseInvigilando.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports